export const MATERIAL_STATUSES = ['Z3', 'Z4', 'Z5', 'Z6'] as const
export type MaterialStatus = (typeof MATERIAL_STATUSES)[number]

export const ABOUT_TO_BE_SOLD_MATERIAL_STATUS = 'Z3'
export const RELEASED_MATERIAL_STATUS = 'Z4'

export const MATERIAL_TYPE = ['material', 'merchandise'] as const
export type MaterialType = (typeof MATERIAL_TYPE)[number]

/**
 * The two entity categories a material can belong to and an account can be licensed to sell.
 * `fz_material.entity_category` and `fz_account.categories_sold` carry them on Nova databases.
 */
export const ENTITY_CATEGORIES = ['FMC', 'NC'] as const
export type EntityCategory = (typeof ENTITY_CATEGORIES)[number]

/**
 * `unassigned` is a filter value, not a category: merchandise has none and some materials have not
 * been given one, so filtering for it is an IS NULL test rather than a value match.
 */
export const UNASSIGNED_ENTITY_CATEGORY = 'unassigned'

export const ENTITY_CATEGORY_FILTER_VALUES = [
  ...ENTITY_CATEGORIES,
  UNASSIGNED_ENTITY_CATEGORY,
] as const

export type EntityCategoryFilterValue = (typeof ENTITY_CATEGORY_FILTER_VALUES)[number]

export const RELEASE_STATUSES = ['released', 'unreleased'] as const
export type ReleaseStatus = (typeof RELEASE_STATUSES)[number]

export const MATERIAL_DISTRIBUTION_CHANNELS = ['domestic', 'export'] as const
export type MaterialDistributionChannel = (typeof MATERIAL_DISTRIBUTION_CHANNELS)[number]

export const MATERIAL_MARKING_CHANNELS = ['DSS', 'MW', 'CDF', 'WH'] as const
export type MaterialMarkingChannel = (typeof MATERIAL_MARKING_CHANNELS)[number]

export const MATERIAL_MARKING_STATUS = ['MK', 'UM'] as const
export type MaterialMarkingStatus = (typeof MATERIAL_MARKING_STATUS)[number]
